export default __webpack_public_path__ + "static/about-us-hero-05888bde5dbcb4408ee99e27602e389b.jpg";